import constants from '../config/constants'
import { store } from '../store/configStore'
import { profileReset } from '../store/reducers/profileSlice'
import { subscriptionAddReset } from '../store/reducers/subscriptionAddSlice'

const userLogsInOptions = ({ grantType, username, password, refreshToken }) => {
  const formData = new URLSearchParams()

  if (grantType === 'client_credentials') {
    formData.append('grant_type', constants.client_auth_method)
    formData.append('client_id', constants.client_credential_id)
    formData.append('client_secret', constants.client_credential_secret)
  }

  if (grantType === 'password') {
    formData.append('grant_type', 'password')
    formData.append('client_id', constants.client_credential_id)
    formData.append('client_secret', constants.client_credential_secret)
    formData.append('username', username)
    formData.append('password', password)
  }

  if (grantType === 'refresh_token') {
    formData.append('grant_type', 'refresh_token')
    formData.append('client_id', constants.client_credential_id)
    formData.append('client_secret', constants.client_credential_secret)
    formData.append('refresh_token', refreshToken)
  }
  
  return (
    {
      method: 'POST',
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: formData.toString(),
      json: true,
    }
  )
}

export const getPublicAccessToken = async () => {
  const response = await fetch(
    constants.auth_server_url,
    userLogsInOptions({ grantType: 'client_credentials' }),
  )

  const responseJson = await response.json()
  
  if (responseJson.error) {
    console.error('error', responseJson.error)
    return null
  }
  
  return responseJson.access_token
}

export const getUserTokens = async ({ grantType, username, password, refreshToken }) => {
  const response = await fetch(
    constants.auth_server_url,
    userLogsInOptions({ grantType, username, password, refreshToken }),
  )
  
  const responseJson = await response.json()
  
  if (responseJson.error) {
    console.error('error', responseJson.error)
    return null
  }
  
  return responseJson
}

export const userLogout = () => {
  store.dispatch(profileReset())
  store.dispatch(subscriptionAddReset())
}